import React from "react";
import styles from "./Footer.module.scss";
import socials from "./pogr-socials.json";
import links from "./pogr-links.json";

type Props = {};

const ID_PREFIX = "footer";

function Footer({}: Props) {
  return (
    <div
      id={`${ID_PREFIX}-container`}
      data-pogr-id={`${ID_PREFIX}-container`}
      className={styles.container}
    >
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
    
    {/* Product */}
    <div>
      <h3 className="text-white font-semibold mb-4 text-base lg:!text-lg">Product</h3>
      <ul className="space-y-2 text-[#8484a5]">
        <li><a href="#" className="hover:!text-cyan-400">Beta Access</a></li>
        <li><a href="#" className="hover:!text-cyan-400">Documentation</a></li>
        <li><a href="#" className="hover:!text-cyan-400">Blog &amp; News</a></li>
        <li><a href="#" className="hover:!text-cyan-400">Listen to Our Podcast</a></li>
      </ul>
    </div>

    {/* Company */}
    <div>
      <h3 className="text-white font-semibold mb-4 text-base lg:!text-lg">Company</h3>
      <ul className="space-y-2 text-[#8484a5]">
        <li><a href="#" className="hover:!text-cyan-400">Privacy Policy</a></li>
        <li><a href="#" className="hover:!text-cyan-400">Job Openings</a></li>
        <li><a href="#" className="hover:!text-cyan-400">Terms of Service</a></li>
      </ul>
    </div>

    {/* Get in touch */}
    <div className="w-60">
      <h3 className="text-white font-semibold mb-4 text-base lg:!text-lg">Get in touch with us</h3>
      <div className="grid grid-cols-4 gap-3 mb-4">
  {socials.map((s, i) => (
    <a
      key={`social-link-${s.title}-${i}`}
      id={`${ID_PREFIX}-link-${s.title}-${i}`}
      data-pogr-id={`${ID_PREFIX}-link-${s.title}-${i}`}
      href={s.url}
      target="_blank"
      rel="noreferrer"
      className="flex items-center justify-center p-2 bg-gray-800 rounded hover:scale-110 transition-transform"
    >
      <img src={s.img} alt={s.title} className="h-8 w-8" />
    </a>
  ))}
</div>

      <p className="text-[#8484a5] !text-sm">info@pogr.io</p>
    </div>

  </div>

     
    </div>
  );
}

export default Footer;
